(function (angular) {
    'use strict';

    angular.module('app.activation').controller('app.activation.ActivateUserController', [
        'ActivationService',
        'ui',
        '$location',
        function ActivateUserController(service, ui, location) {
            var vm = this;

            //Model Properties
            vm.newPassword = '';
            vm.hidePassword = true;
            vm.confirmPassword = '';
            vm.hideConfirmPassword = true;
            vm.accountAlreadyExists = false;
            vm.emailAlreadyExists = false;
            vm.passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$';
            vm.memberPortalSignIn = environment.memberPortalUrl;
            vm.userId = retrieveIdFromUrl();

            vm.user = {
                lastName: '',
                birthDate: '',
                memberId: '',
                email: '',
                userId: '',
                password: '',
                zipCode: ''
            };

            if (vm.userId !== null) {
                ui.block();
                skipFirstStep();
            }

            //Form Wizard properties
            vm.currentStep = 'activate-account-pg-one';
            vm.isActivateTransitionAnimtation = false;
            vm.activated = false;

            //Controller Actions
            vm.activateAccount = activateAccount;
            vm.gotoNextStep = gotoNextStep;
            vm.goToActivateAccount = goToActivateAccount;
            vm.manageFormWizard = manageFormWizard;
            vm.noMatch = noMatch;

            if (environment.cookieDomain !== '') {
                document.cookie = 'patolus.identity' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
                document.cookie =
                    'patolus.identity' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;domain=' + environment.cookieDomain;
            } else {
                document.cookie = 'patolus.identity' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
                document.cookie = 'patolus.identity' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT';
            }

            //retrieve member id from query parameter
            function retrieveIdFromUrl() {
                var userId = location.search().id;
                if (userId) {
                    return userId;
                } else {
                    return null;
                }
            }

            function hideWizardButtons() {
                // Locate the desired step to navigate to
                var destinationStepNumber = 'activate-account-pg-two';

                // Hide current step
                var elementCurrentStep = document.getElementById(vm.currentStep);
                elementCurrentStep.classList.add('hidden');

                // Show destination step
                var elementDestinationStep = document.getElementById(destinationStepNumber);
                elementDestinationStep.classList.remove('hidden');

                // Update Indicator
                var currenIndicatorId = 'i-' + vm.currentStep;
                var nextIndicatorId = 'i-' + destinationStepNumber;

                var elementCurrentStepIndicator = document.getElementById(currenIndicatorId);
                var elementNextStepIndicator = document.getElementById(nextIndicatorId);

                elementCurrentStepIndicator.classList.add('hidden');

                if (elementNextStepIndicator) {
                    elementNextStepIndicator.classList.add('hidden');
                }

                // Finally keep track of where we are
                vm.currentStep = destinationStepNumber;
            }

            vm.togglePassword = function () {
                vm.hidePassword = !vm.hidePassword;
            };

            vm.toggleConfirmPassword = function () {
                vm.hideConfirmPassword = !vm.hideConfirmPassword;
            };

            //Check that both passwords match
            function noMatch() {
                return !(vm.user.password === vm.confirmPassword);
            }

            function goToActivateAccount($event) {
                vm.manageFormWizard($event);
            }

            function skipFirstStep() {
                vm.user.userId = vm.userId;
                service
                    .checkActivationStatus(vm.user)
                    .then(function fulfilled(response) {
                        handleActivationCheckResponse(response);
                    })
                    .catch(function rejected(response) {
                        ui.handleError(response);
                    })
                    .finally(function final() {
                        ui.unblock();
                    });
            }

            function handleActivationCheckResponse(resp) {
                //If a user exists
                //AND they have a login, then they've already been activated so redirect
                if (resp.data.userName != null) {
                    window.location = vm.memberPortalSignIn;
                }

                if (resp.data.userId != null) {
                    hideWizardButtons();
                }

                //If the user doesn't exist at all, throw an error. New users can not be added form the activate page.
                if (resp.data.notFound === true) {
                    ui.error('Account not found');
                }
            }

            ////Form Wizard helper functions\\\\
            function gotoNextStep($event, formValid) {
                //Ensure the form inputs are valid before continuing. This prevents the user from moving forward
                //with the "step" indicator at the bottom of the page, unless the form is valid.
                if (!formValid) {
                    ui.warning('Please complete all required inputs before continuing');
                    return;
                }

                ui.block();

                //Check for an existing user. If the user exist, check if the user has been "activated" (i.e. whether they have a login email)
                service
                    .isExistingUserActive(vm.user)
                    .then(function fulfilled(response) {
                        // There can only be one.
                        if (response.data.searchResultCount !== 1) {
                            ui.error(
                                'We are unable to uniquely identify this account. To complete this activation please contact Wellfit customer service.'
                            );
                            ui.unblock();
                        }

                        //If a user exists that matches all 3 properties (lastName, birthDate, and zipcode),
                        //AND they have a login, then they've already been activated so show an error
                        if (response.data.userName != null) {
                            vm.accountAlreadyExists = true;
                            ui.warning('A login already exists for this user.');
                            ui.unblock();
                            return;
                        }

                        //If a user already exists that matches all 3 properties (lastName, birthDate, and zipcode),
                        //but they do NOT have a login (i.e. userId), then take them to the next page to be activated
                        if (response.data.userId != null) {
                            vm.user.userId = response.data.userId;
                            manageFormWizard($event);
                        }
                    })
                    .catch(function rejected(response) {
                        ui.handleError(response);
                        ui.unblock();
                    });
            }

            function activateAccount($event) {
                ui.block();

                //See if the email is already in use by another user
                service
                    .getUserIdByEmail(vm.user.email)
                    .then(function fulfilled(response) {
                        //If response contains a userId then let the user know the email already exists
                        if (response.data != null && response.data != '' && !vm.shouldMergeExistingAccounts) {
                            vm.emailAlreadyExists = true;
                            ui.warning('The email entered is already in use.');
                            ui.unblock();
                        } else {
                            //Activate the User
                            service
                                .activateExistingUserAccount(vm.user, vm.shouldMergeExistingAccounts)
                                .then(function fulfilled(response) {
                                    vm.activated = true;
                                    vm.manageFormWizard($event);
                                })
                                .catch(function rejected(response) {
                                    ui.handleError(response);
                                    ui.unblock();
                                });
                        }
                    })
                    .catch(function rejected(response) {
                        ui.handleError(response);
                        ui.unblock();
                    });
            }

            //Form Wizard
            function manageFormWizard($event) {
                // Animation
                vm.isActivateTransitionAnimaation = true;
                setTimeout(function transitionAnimation() {
                    vm.isActivateTransitionAnimtation = false;
                }, 100);

                // Locate the desired step to navigate to
                var destinationStepNumber = $event.currentTarget.getAttribute('data-destination-step');

                // Hide current step
                var elementCurrentStep = document.getElementById(vm.currentStep);
                elementCurrentStep.classList.add('hidden');

                // Show destination step
                var elementDestinationStep = document.getElementById(destinationStepNumber);
                elementDestinationStep.classList.remove('hidden');

                // Update Indicator
                var currenIndicatorId = 'i-' + vm.currentStep;
                var nextIndicatorId = 'i-' + destinationStepNumber;

                var elementCurrentStepIndicator = document.getElementById(currenIndicatorId);
                var elementNextStepIndicator = document.getElementById(nextIndicatorId);

                elementCurrentStepIndicator.classList.remove('active');

                if (elementNextStepIndicator) {
                    elementNextStepIndicator.classList.add('active');
                }

                // Finally keep track of where we are
                vm.currentStep = destinationStepNumber;

                // Unblock (moved from individual functions in order to keep spinner until whole call end)
                ui.unblock();
            }

            ////END Form Wizard helper functions//////
        }
    ]);
})(angular);
